import { render, staticRenderFns } from "./editorhistory.vue?vue&type=template&id=6c5746da&scoped=true&"
import script from "./editorhistory.vue?vue&type=script&lang=js&"
export * from "./editorhistory.vue?vue&type=script&lang=js&"
import style0 from "./editorhistory.vue?vue&type=style&index=0&id=6c5746da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5746da",
  null
  
)

export default component.exports